<template>
    <v-layout row justify-center>
        <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="$emit('hide')">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <!--<v-toolbar-items>-->
                        <!--<v-btn dark flat @click="dialog = false">Save</v-btn>-->
                    <!--</v-toolbar-items>-->
                </v-toolbar>
                <div>
                    <v-tabs
                            v-model="active"
                            color="primary"
                            dark
                            slider-color="yellow"
                            centered
                            grow
                    >
                        <v-tab ripple v-if="!registerOnly">LOGIN</v-tab>
                        <v-tab-item v-if="!registerOnly">
                            <v-card flat>
                                <login-manual :add-to-cart="addToCart" :open-cart="openCart" :show-toolbar="false" :show-register-button="false" :event-name="eventName"/>
                            </v-card>
                        </v-tab-item>

                        <v-tab ripple>
                            SIGN UP
                        </v-tab>
                        <v-tab-item>
                            <v-card flat>
                                <register-manual :show-toolbar="false"/>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </div>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    import LoginManual from "../views/LoginManual";
    import RegisterManual from "../views/RegisterManual";
    export default {
        name: "LoginRegisterModal",
        components: {RegisterManual, LoginManual},
        props : {
            dialog : {
                type : Boolean,
                default : false,
            },
            addToCart : {
                type : Boolean,
                default : false,
            },
            openCart : {
                type : Boolean,
                default : false,
            },
            eventName :{
                type : String,
                default : 'event',
            },
            registerOnly: 
            {
                type : Boolean,
                default: false,
            }
        },
        data(){
            return {
                active: null,
            }
        },
        methods: {
            next () {
                const active = parseInt(this.active)
                this.active = (active < 2 ? active + 1 : 0)
            }
        },
        mounted() 
        {
            EventBus.$off('hideRegisterManual');
            EventBus.$on('hideRegisterManual', (data) =>
            {
                this.$emit('hide');
            });
        }
    }
</script>

<style scoped>

</style>